import { Spinner } from '@cian/ui-kit/loader';

import * as styles from './styles.css';

export function MapFullscreenFallback() {
  return (
    <div className={styles['container']}>
      <Spinner color="gray60_100" />
    </div>
  );
}
